<template>
  <div class="layout">
    <nav id="header" class="navbar">
      <div style="width: 1200px;margin: auto;">
        <a class="navbar-brand">
          <template>
            <img class="schoolPhoto" :src="schoolPhoto" v-if="schoolPhoto" />
            <img src="../assets/XunwLogo.png" class="schoolPhoto" v-else />
            <!-- <span class="pl-2" v-if="websiteName"> &nbsp;| &nbsp;{{ websiteName }}</span>
            <span class="pl-2" v-else> &nbsp;| &nbsp;成人教育管理平台</span> -->
          </template>
        </a>
      </div>
    </nav>
    <div class="container" style="height: 100%; padding: 24px 0">
      <div>
        <div class="side">
          <div class="user">
            <b-avatar :src="userPhoto" size="6rem"></b-avatar>
            <div class="p-2">
              <b-dropdown variant="btn-link">
                <template #button-content>
                  <span class="text-white h4" style="color:#333 !important">{{
                      $store.state.user.name
                    }}</span>
                </template>
                <b-dropdown-item @click="showPassForm = true">修改密码</b-dropdown-item>
                <b-dropdown-item @click="logout">退出</b-dropdown-item>
              </b-dropdown>
            </div>

            <router-link :to="{ path: '/main/message' }" :class="{ active: $route.path === '/main/message' }">
              <el-badge :is-dot="isDot">
                <b-icon-bell></b-icon-bell>
              </el-badge>
            </router-link>
          </div>
          <ul id="nav" class="nav flex-column text-left" v-if="isRegInfo&&regInfo.studentStatus==='ADMIT'">
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/home' }"
                           :class="{ active: $route.path === '/main/home' }">
                <b-icon-house-door></b-icon-house-door>
                <span class="pl-md-3">我的首页</span>
              </router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/readyExam' }" :class="{ active: $route.path === '/main/readyExam' }">
                <b-icon-window></b-icon-window>
                <span class="pl-md-3">备战考试</span>
              </router-link>
            </li> -->
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/order' }"
                           :class="{ active: $route.path === '/main/order' }">
                <b-icon-bag-check></b-icon-bag-check>
                <span class="pl-md-3">我的缴费</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/homework' }"
                           :class="{ active: $route.path === '/main/homework' }">
                <b-icon-book></b-icon-book>
                <span class="pl-md-3">教学计划 </span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/course' }"
                           :class="{ active: $route.path === '/main/course' }">
                <b-icon-window></b-icon-window>
                <span class="pl-md-3">我的课程 </span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/notSpecialtyCourse' }"
                           :class="{ active: $route.path === '/main/notSpecialtyCourse' }">
                <b-icon-layout-split></b-icon-layout-split>
                <span class="pl-md-3">非专业课 </span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/myHomework' }"
                           :class="{ active: $route.path === '/main/myHomework' }">
                <b-icon-receipt></b-icon-receipt>
                <span class="pl-md-3">我的作业 </span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/exam' }"
                           :class="{ active: $route.path === '/main/exam' }">
                <b-icon-brush></b-icon-brush>
                <span class="pl-md-3">我的考试</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/resitApply' }"
                           :class="{ active: $route.path === '/main/resitApply' }">
                <b-icon-calendar></b-icon-calendar>
                <span class="pl-md-3">重修申请</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/thesis' }"
                           :class="{ active: $route.path === '/main/thesis' }">
                <b-icon-file-earmark-text></b-icon-file-earmark-text>
                <!-- <span class="pl-md-3">毕业论文</span> -->
                <span class="pl-md-3">毕业设计</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/thesis2' }"
                           :class="{ active: ($route.path === '/main/thesis2'||$route.path === '/main/addThesisProposal'||$route.path === '/main/myThesisProposal'||$route.path === '/main/updateThesisProposal'||$route.path === '/main/mySpotCheck') }">
                <b-icon-file-earmark-text></b-icon-file-earmark-text>
                <span class="pl-md-3">毕业论文</span>
                <!-- <span class="pl-md-3">毕业设计</span> -->
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/onlineDefenseList' }"
                           :class="{ active: ($route.path === '/main/onlineDefenseList') }">
                <b-icon-file-earmark-text></b-icon-file-earmark-text>
                <span class="pl-md-3">论文答辩</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/score' }"
                           :class="{ active: $route.path === '/main/score' }">
                <b-icon-card-text></b-icon-card-text>
                <span class="pl-md-3">我的成绩</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/exemption' }"
                           :class="{ active: $route.path === '/main/exemption' }">
                <b-icon-card-checklist></b-icon-card-checklist>
                <span class="pl-md-3">课程免考</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/grad' }"
                           :class="{ active: $route.path === '/main/grad' }">
                <b-icon-bag-check></b-icon-bag-check>
                <span class="pl-md-3">我的毕业</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/degree' }"
                           :class="{ active: $route.path === '/main/degree' }">
                <b-icon-envelope></b-icon-envelope>
                <span class="pl-md-3">学位申请</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/Excellent' }"
                           :class="{ active: $route.path === '/main/Excellent' }">
                <b-icon-window></b-icon-window>
                <span class="pl-md-3">优秀毕业生</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/register' }"
                           :class="{ active: $route.path === '/main/register' }">
                <b-icon-people></b-icon-people>
                <span class="pl-md-3">学籍变更</span>
              </router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/myOrder' }" :class="{ active: $route.path === '/main/myOrder' }">
                <b-icon-receipt></b-icon-receipt>
                <span class="pl-md-3">我的订单</span>
              </router-link>
            </li> -->
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/profile' }"
                           :class="{ active: $route.path === '/main/profile' }">
                <b-icon-person></b-icon-person>
                <span class="pl-md-3">个人资料</span>
              </router-link>
            </li>
          </ul>
          <ul id="nav" class="nav flex-column text-left" v-else-if="isRegInfo&&regInfo.studentStatus==='GRADUATE'">
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/thesis2' }"
                           :class="{ active: ($route.path === '/main/thesis2'||$route.path === '/main/addThesisProposal'||$route.path === '/main/myThesisProposal'||$route.path === '/main/updateThesisProposal'||$route.path === '/main/mySpotCheck') }">
                <b-icon-file-earmark-text></b-icon-file-earmark-text>
                <span class="pl-md-3">毕业论文</span>
                <!-- <span class="pl-md-3">毕业设计</span> -->
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/onlineDefenseList' }"
                           :class="{ active: ($route.path === '/main/onlineDefenseList') }">
                <b-icon-file-earmark-text></b-icon-file-earmark-text>
                <span class="pl-md-3">论文答辩</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/score' }"
                           :class="{ active: $route.path === '/main/score' }">
                <b-icon-card-text></b-icon-card-text>
                <span class="pl-md-3">我的成绩</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/grad' }"
                           :class="{ active: $route.path === '/main/grad' }">
                <b-icon-bag-check></b-icon-bag-check>
                <span class="pl-md-3">我的毕业</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/degree' }"
                           :class="{ active: $route.path === '/main/degree' }">
                <b-icon-envelope></b-icon-envelope>
                <span class="pl-md-3">学位申请</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/Excellent' }"
                           :class="{ active: $route.path === '/main/Excellent' }">
                <b-icon-window></b-icon-window>
                <span class="pl-md-3">优秀毕业生</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/profile' }"
                           :class="{ active: $route.path === '/main/profile' }">
                <b-icon-person></b-icon-person>
                <span class="pl-md-3">个人资料</span>
              </router-link>
            </li>
          </ul>
          <ul id="nav" class="nav flex-column text-left"
              v-else-if="isRegInfo&&(regInfo.studentStatus==='QUIT_SCHOOL'||regInfo.studentStatus==='DROP_OUT')">
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/register' }"
                           :class="{ active: $route.path === '/main/register' }">
                <b-icon-people></b-icon-people>
                <span class="pl-md-3">学籍变更</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/profile' }"
                           :class="{ active: $route.path === '/main/profile' }">
                <b-icon-person></b-icon-person>
                <span class="pl-md-3">个人资料</span>
              </router-link>
            </li>
          </ul>
          <ul id="nav" class="nav flex-column text-left" v-else>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/readyExam' }"
                           :class="{ active: $route.path === '/main/readyExam' }">
                <b-icon-window></b-icon-window>
                <span class="pl-md-3">备战考试</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/myOrder' }"
                           :class="{ active: $route.path === '/main/myOrder' }">
                <b-icon-receipt></b-icon-receipt>
                <span class="pl-md-3">我的订单</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="{ path: '/main/profile' }"
                           :class="{ active: $route.path === '/main/profile' }">
                <b-icon-person></b-icon-person>
                <span class="pl-md-3">个人资料</span>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="view">
          <router-view/>
        </div>
      </div>
    </div>

    <b-modal v-model="showPassForm" title="修改密码" cancel-title="关闭" ok-title="确定" hide-footer>
      <div class="p-2">
        <div v-if="
            passwordForm.confirmPass &&
            passwordForm.newPass !== passwordForm.confirmPass
          " class="alert alert-danger" role="alert">
          新密码与确认密码输入不一致
        </div>
        <b-form @submit.stop.prevent="chPass">
          <b-form-group label-cols="3" label-for="oldPass">
            <template #label>
              <span class="text-danger">*</span>
              原密码:
            </template>
            <b-form-input id="oldPass" type="password" v-model="passwordForm.oldPass" placeholder="请输入原密码"
                          required></b-form-input>
          </b-form-group>
          <b-form-group label-cols="3" label-for="newPass">
            <template #label>
              <span class="text-danger">*</span>
              新密码:
            </template>
            <b-form-input id="newPass" type="password" v-model="passwordForm.newPass" placeholder="6至18位" required
                          minlength="6" maxlength="18"></b-form-input>
          </b-form-group>
          <b-form-group label-cols="3" label-for="confirmPass">
            <template #label>
              <span class="text-danger">*</span>
              确认新密码:
            </template>
            <b-form-input id="confirmPass" type="password" v-model="passwordForm.confirmPass" placeholder="请确认新密码"
                          required minlength="6" maxlength="18"></b-form-input>
          </b-form-group>
          <div class="p-2 text-center">
            <button type="submit" :disabled="loading" class="btn btn-primary rounded-pill" style="width: 120px">
              <span class="px-1">提交</span>
            </button>
          </div>
        </b-form>
      </div>
    </b-modal>

    <AI />
  </div>
</template>

<script>
import {logout, checkToken} from "@/api";
import AI from "./AI.vue";
import {mapState} from "vuex"

export default {
  name: "Layout",
  components: {
    AI
  },
  data() {
    return {
      loading: false,
      showPassForm: false,
      passwordForm: {
        oldPass: null,
        newPass: null,
        confirmPass: null,
      },
      regInfo: {},
      schoolPhoto: null,
      schoolName: null,
      websiteName: null,
      userPhoto: require(`@/assets/user.png`),
      isRegInfo: true,
      refreshLock: false,
      refreshTime: null,
      isDot: false
    };
  },
  computed: {
    ...mapState(['sysConfig','user'])
  },
  created() {
    document.body.style.filter = ''
    this.regInfo = this.user.regInfo
    if (this.regInfo) {
      this.isRegInfo = true
      this.schoolPhoto = this.regInfo.schoolPhoto
      this.schoolName = this.regInfo.schoolName
      this.websiteName = this.regInfo.websiteName
      document.title = this.schoolName;
      this.userPhoto = this.regInfo.photoUrl ? this.regInfo.photoUrl : require(`@/assets/user.png`)
      if (this.regInfo.studentStatus === 'QUIT_SCHOOL' || this.regInfo.studentStatus === 'DROP_OUT') {
        this.$router.push({name: "register"})
      } else if (this.regInfo.studentStatus === 'GRADUATE') {
        this.$router.push({name: "grad"})
      }
    } else {
      this.isRegInfo = false
    }
  },
  mounted() {
    this.refreshToken();
    this.getIsDot();
    setInterval(async () => {
      const res = await this.axios.get("/student/message/user/page?readFlag=0&userType=TOC");
      this.isDot = res.data.data.total !== 0;
    },30*60*1000)
  },
  destroyed() {
    clearInterval(this.refreshTime);
  },
  methods: {
    // 获取是否显示未读
    async getIsDot() {
      const res = await this.axios.get("/student/message/user/page?readFlag=0&userType=TOC");
      this.isDot = res.data.data.total !== 0;
      if (this.isDot)
        this.$router.push({name: "message"})
    },
    refreshToken() {
      // console.log('refreshToken')
      this.refreshTime = setInterval(() => {
        checkToken(this.refreshTime, this.refreshLock);
      }, 10*60*1000);
    },
    logout() {
      logout()
      if (this.$store.state.config.zhuti === 'newyear') {
        this.$router.push({name: "newyear"})
      } else {
        this.$router.push({name: "Login"})
      }
    },
    async chPass() {
      this.loading = true;
      try {
        await this.axios.patch("/student/password", this.passwordForm);
        this.showPassForm = false;
        this.passwordForm = {
          oldPass: null,
          newPass: null,
          confirmPass: null,
        };
        this.$bvToast.toast("修改成功", {
          title: "提示",
          variant: "success",
          solid: true,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  background-repeat: no-repeat;
  background-size: 100% 260px;

  .navbar {
    background: url('../assets/home.png');
    height: 100px;
    border-bottom: 6px solid #3A77A8;
  }

  .schoolPhoto {
    height: 3.5rem;
  }
}

.navbar-brand {
  color: #093151;
  font-size: 1.5rem;
}

.user {
  text-align: center;
  padding-top: 10px;
  // .dropdown-toggle::after {
  //   color: #fff;
  // }
  // .b-avatar {
  //   border: solid 1px #fff;
  // }
}

.side {
  width: 200px;
  float: left;
  background: #fff;
  box-shadow: 0px 0px 5px 1px rgba(221, 221, 221, 0.5);
  border-radius: 5px;
}

.view {
  margin-left: 200px;
}

#nav {
  padding: 30px;

  li {
    padding: 4px 0;
  }

  a {
    font-size: 16px;
    color: #2c3e50;
    padding: 8px 10px;
  }

  a:hover,
  .nav-link.active {
    background-color: rgba($primary, 0.1);
    border-radius: 20px;
    font-weight: bold;
    color: $primary;
  }
}
</style>
